<div id="header">
  <div id="top-header" class="pt-3">
    <div class="container">
      <div class="row py-1">
        <div class="col-9 px-lg-0">
          <ul class="nav justify-content-start align-items-center">
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" href="mailto: info@tagoreglobalschool.in"><i class="fa-solid fa-envelope me-2"></i>info@tagoreglobalschool.in</a>
            </li>
          </ul>
        </div>
        <div class="col-3 px-lg-0">
          <ul class="nav justify-content-end">
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" routerLink="/faq">FAQ</a>
            </li>
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" routerLink="/career" >Career</a>
            </li>
            <li class="nav-item bg-success">
              <a class="nav-link py-1 text-white" routerLink="/contact-us" >Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  
  <div id="middle-header">
    <div class="container">
      <div class="row">
        <div class="col-12 px-lg-0">
          <ul class="nav justify-content-end animate__animated animate__backInUp">
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" href="https://www.facebook.com/tgskkr" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
            </li>
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" href="https://www.instagram.com/tgskkr18/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
            </li>
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" href="https://www.youtube.com/tagoreglobalschoolkkr" target="_blank"><i class="fa-brands fa-youtube"></i></a>
            </li>
            <li class="nav-item hoverLink">
              <a class="nav-link py-1" href="https://www.linkedin.com/in/tagore-global-school-kkr-225aa4193/?originalSubdomain=in" target="_blank"><i class="fa-brands fa-linkedin-in"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  
  <div id="menu">
  <div class="container px-lg-0">
    <nav class="navbar navbar-expand-lg bg-body-tertiary py-0">
      <div class="container-fluid px-lg-0">
        <a class="navbar-brand" routerLink="/"><img src="/assets/img/logo/1.png" alt="Logo" class="img-fluid"></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link" aria-current="page" routerLink="/">Home</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                About 
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/about/overview">About TGS</a></li>
                <li><a class="dropdown-item" routerLink="/about/vision">Mission & Vision</a></li>
                <li><a class="dropdown-item" routerLink="/about/director">Director's Message</a></li>
                <li><a class="dropdown-item" routerLink="/about/principal">Principal's Message</a></li>
                <li><a class="dropdown-item" routerLink="/about/team">Our Team</a></li>
                <li><a class="dropdown-item" routerLink="/about/student-council">Student Council</a></li>
                <li><a class="dropdown-item" routerLink="/about/facilities">Facilities</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Rules
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/rules/school-timing">School Timing</a></li>
                <li><a class="dropdown-item" routerLink="/rules/rules-regulations">Rules & Regulation</a></li>
                <li><a class="dropdown-item" routerLink="/rules/school-uniform">School Uniform</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Infra
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/infra/building">School Building</a></li>
                <li><a class="dropdown-item" routerLink="/infra/labs">Labs <i class="fa-solid fa-angle-right float-end"></i></a>
                  <ul class="dropdown-menu dropdown-submenu">
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/physics">Physics Lab</a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/chemistry">Chemistry Lab</a>
                    </li>
                  
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/biology">Biology Lab</a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/computer">Computer Lab</a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/math">Math Lab</a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/infra/labs/language">Language Lab</a>
                    </li>
                  </ul>
                </li>
                <li><a class="dropdown-item" routerLink="/infra/studio">Studio<i class="fa-solid fa-angle-right float-end"></i></a>
                  <ul class="dropdown-menu dropdown-submenu">
                    <li>
                      <a class="dropdown-item" routerLink="/infra/studio/art">Art Studio</a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/infra/studio/music">Music Studio</a>
                    </li>
                  
                    <li>
                      <a class="dropdown-item" routerLink="/infra/studio/dance">Dance Studio</a>
                    </li>
                  </ul>
                </li>
                <li><a class="dropdown-item" routerLink="/infra/gymnasium">Gymnasium</a></li>
                <li><a class="dropdown-item" routerLink="/infra/yoga-room">Yoga Room</a></li>
                <li><a class="dropdown-item" routerLink="/infra/indoor-game-room">Indoor Games Room</a></li>
                <li><a class="dropdown-item" routerLink="/infra/playgrounds">Playgrounds</a></li>
                <li><a class="dropdown-item" routerLink="/infra/auditorium">Auditorium</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Calender
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/calendar/academic">Academic Schedule</a></li>
                <li><a class="dropdown-item" routerLink="/calendar/activities">Activities Schedule</a></li>
                <li><a class="dropdown-item" routerLink="/calendar/club">Clubs Schedule</a></li>
                <li><a class="dropdown-item" routerLink="/calendar/holidays">School Holidays</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Achievers
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/achievers/board-result">Board Results</a></li>
                <li><a class="dropdown-item" routerLink="/achievers/school-result">School Results</a></li>
                <li><a class="dropdown-item" routerLink="/achievers/inter-school-competition">Inter School Competition</a></li>
                <li><a class="dropdown-item" routerLink="/achievers/house-club-competition">House/Club Competition</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Gallery
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/gallery">Album</a></li>
                <li><a class="dropdown-item" routerLink="/video-gallery">Videos</a></li>
                <li><a class="dropdown-item" routerLink="/media">News & Media Coverage</a></li>
                <li><a class="dropdown-item" routerLink="/testimonial">Testimonials</a></li>
              </ul>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link"
               routerLink="/blogs">Blogs</a>
          </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
               Admission
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" routerLink="/admission/admission-process">Admission Process</a></li>
                <li><a class="dropdown-item" routerLink="/admission/admission-form">Admission Form</a></li>
                <li><a class="dropdown-item" routerLink="/admission/fee">Fee Structure</a></li>
                <li><a class="dropdown-item" href="https://tgs.schoolsar.com/Website/RegisterStudent" target="_blank">Click For Online Admissions</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
               Login
              </a>
              <ul class="dropdown-menu hover-dropdown">
                <li><a class="dropdown-item" href="https://odp.page.link/app" target="_blank">Parent</a></li>
                <li><a class="dropdown-item" href="https://tgs.schoolsar.com/Account/Login" target="_blank">Staff</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  </div>
</div>